export default __webpack_public_path__ + "static/bn-63e4c30ad1e1b5b06edde8a122c9722a.svg";